import React from 'react';
import type { FC, ReactNode } from 'react';
import Button from '@mui/material/Button';
import './CustomButton.css';
import Box from '@mui/material/Box';

interface CustomButtonProps {
  id: string;
  children?: ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  variant?: 'text' | 'outlined' | 'contained';
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  disabled?: boolean;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  href?: string;
  size?: 'small' | 'medium' | 'large';
  autoFocus?: boolean;
}

const CustomButton: FC<CustomButtonProps> = ({
  id,
  children,
  onClick,
  type,
  className,
  variant = 'contained',
  color = 'primary',
  disabled = false,
  startIcon,
  endIcon,
  href,
  size = 'small',
  autoFocus = false,
}) => {
  return (
    <Box sx={{ padding: 'none' }}>
      <Button
        id={id}
        variant={variant}
        color={color}
        className={className}
        type={type}
        onClick={onClick}
        disabled={disabled}
        startIcon={startIcon}
        endIcon={endIcon}
        href={href}
        size={size}
        autoFocus={autoFocus}
        sx={{ textTransform: 'none' }}
      >
        {children}
      </Button>
    </Box>
  );
};

export default CustomButton;
